module.exports = __webpack_public_path__ + "img/no_list.8e0f8e04.png";